import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import { Subscription } from 'rxjs';
import { RoleService } from '../shareModule/services/roles/role.service';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { SharedService } from '../shareModule/services/shared.service';
import { ModalService } from '../shareModule/services/modal.service';

@Component({
  selector: 'app-poll-card',
  templateUrl: './poll-card.component.html',
  styleUrl: './poll-card.component.scss'
})
export class PollCardComponent implements OnInit, OnDestroy, OnChanges {

  @Input()
  public pollData;

  @Input()
  public showAdd = false

  @Input()
  public addTagWithSameNameWhenOptionClicked = false;

  @Input()
  public hideImage = false
  
  @Output()
  selectedPoll = new EventEmitter<string>()

  constructor(private local: LocalServiceService, private roleService: RoleService, private auth: AuthServiceService,
     private sharedService: SharedService, private cdr: ChangeDetectorRef, private modalService: ModalService){}
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['pollData']){
      this.initPoll();
    }
  }
  ngOnDestroy(): void {
    this._userDetailsSubscriber?.unsubscribe()
    this._roleSubscription?.unsubscribe();
  }

  private _userDetailsSubscriber : Subscription = null;
  private _roleSubscription : Subscription = null;

  public isLogin = false;
  public isUserAdmin = false;
  public appUserId;


  
  ngOnInit(): void {
    this._roleSubscription?.unsubscribe();
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isUserAdmin = this.roleService?.roles?.userType.includes('ADMIN')
    })


    this._userDetailsSubscriber?.unsubscribe();
    this._userDetailsSubscriber = this.local.getUserDetailsObserver().subscribe((user)=>{
      this.isLogin = !!user;
      if(this.isLogin){
        this.appUserId = user.id;
      }else{
        this.appUserId = null;
      }
      this.cdr.detectChanges()
    })
    this.initPoll()
  
  }
  

  initPoll() {

    if(this.sharedService.isBrowser()){
      this.initPollProgress();
   
     // this.showDetail('poll');
    }
  }

  public newPolling = {}


  openNewOptionModal(event: any, modal: any, item: any) {
    try {
      event.preventDefault();
      this.modalService.dismissAll();
      this.modalService.open(modal, {
        size: 'sm',
        // backdrop: 'static',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'new_polling_option_modal',
      });
      this.newPolling = {
        title: item.name,
        id: item.id,
        option: '',
      };
    } catch (error) {
      console.error('Error opening new option modal:', error);
    }
  }


  hasCheckedPoll(data: any) {
    return (
      data.filter(
        (row: any) =>
          row.userId == this.appUserId
      ).length > 0
    );
  }




  checkPoll(data: any, child: any, check = false) {

    try{
      console.log('checking poll', {arguments})
      const payload = {
        userId: this.appUserId,
        pollDetailId: child.id,
        addTagWithSameNameWhenOptionClicked: false
      };
  
      if (this.hasCheckedPoll(child.poll_interactions)) {
        data.poll_interactions_count -= 1;
        child.poll_interactions = child.poll_interactions.filter(
          (row: any) =>
            row.userId != this.appUserId && row.isAdmin != this.isUserAdmin
        );
      } else {
        data.poll_interactions_count += 1;
        child.poll_interactions = [...child.poll_interactions, payload];
      }
  
      if(this.addTagWithSameNameWhenOptionClicked){
        payload.addTagWithSameNameWhenOptionClicked = true;
      }
      this.pollProgress(data, child);
      this.initPollProgress(data.id, child.id);
      this.auth.poll_check(payload).subscribe({
        next: ()=>{
          console.log("checked")
          this.selectedPoll.next(child.name)
        },
        error: console.error
      });
      this.cdr.detectChanges()

    }catch(e){
      console.error(e)
    }
   
  }

  pollProgress(data: any, child: any) {
    const result =
      (child.poll_interactions.length / data.poll_interactions_count) * 100;
    child.progress = (result ? result : 0) + '%';
  }

  startCountdown(item: any): void {
    item.interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(item.endDate).getTime() - now;

      if (distance < 0) {
        clearInterval(item.interval);
        item.remainingTime = "Time's up!";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      item.remainingTime =
        (days > 0 ? days + 'd ' : '') +
        (hours < 10 ? '0' + hours : hours) +
        ':' +
        (minutes < 10 ? '0' + minutes : minutes) +
        ':' +
        (seconds < 10 ? '0' + seconds : seconds);
        this.cdr.detectChanges()
    }, 1000);
  }


  pollsColor: any = [
    'rgba(var(--secondary-r), var(--secondary-g), var(--secondary-b), 0.75)',
    '#3597DA',
    '#E67F22',
  ];
  initPollProgress(dataId: any = null, exceptId: any = null) {
    try{
      const row = this.pollData
      row.progress = 0;

      this.startCountdown(row);
      row.poll_interactions_count = 0;
      row.poll_details.forEach((item: any) => {
        item.progress = 0;
        if (exceptId != null && dataId != null) {
          if (item.id != exceptId && dataId == row.id) {
            item.poll_interactions = item.poll_interactions.filter(
              (row: any) =>
                row.userId != this.appUserId && this.isUserAdmin
            );
          }
        }
        row.poll_interactions_count += item.poll_interactions.length;
      });
      row.poll_details.map((item: any) => {
        this.pollProgress(row, item);
      });
      row.poll_details.sort(
        (a: any, b: any) =>
          b.poll_interactions.length - a.poll_interactions.length
      );
      this.cdr.detectChanges()
      
    }catch(e){
      console.error(e)
    }

    
  }

}
